import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useMorningOperationsProgress — small hook that returns the current
 * "Start the Day" completion state for sidebar / OCC indicators.
 *
 * Returns:
 *   { completed: number, total: number, overallStatus, refresh }
 *
 * Polls every 30 seconds so the sidebar badge stays accurate even
 * when the user completes a step in another tab.
 */
const TOTAL_STEPS = 4;

export function useMorningOperationsProgress() {
  const [state, setState] = useState({ completed: 0, total: TOTAL_STEPS, overallStatus: null });

  async function refresh() {
    try {
      const { data } = await api.get("/morning-operations/state");
      const steps = data?.steps || {};
      const completed = Object.values(steps).filter((s) => s?.status === "COMPLETE").length;
      setState({ completed, total: TOTAL_STEPS, overallStatus: data?.overall_status || null });
    } catch { /* silent — sidebar badge is best-effort */ }
  }

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, []);

  return { ...state, refresh };
}
